import React from 'react';
import './Breadcrumb.css';

const Breadcrumb = ({ activePage }) => {
  const pageNames = {
    hero: 'Hero',
    about: 'About',
    skills: 'Skills',
    experience: 'Experience',
    projects: 'Projects',
    education: 'Education',
    contact: 'Contact'
  };

  return (
    <div className="breadcrumb">
      <div className="breadcrumb-path">
        <span className="path-item">portfolio</span>
        <span className="path-separator">›</span>
        <span className="path-item">pages</span>
        <span className="path-separator">›</span>
        <span className="path-item active">{pageNames[activePage] || 'Hero'}.js</span>
      </div>
    </div>
  );
};

export default Breadcrumb;
